<template>
    <div :class="{'available-animate': availableAnimate}">
        <ul class="china_list d-flex flex-wrap" >
            <li v-for="(post, index) in posts" :key="post.id" v-animate="'slide-in-up'">
                <a href="#" v-b-modal="'modal-location-' + (index + 1)">
                    <div class="compare_area fw-bold"><span>Compare</span></div>
                    <div class="compare_image">
                        <img :src="post.image_hover" :alt="post.title" class="image bottom">
                        <img :src="post.image" :alt="post.title" class="image top">
                    </div>
                </a>
            </li>
        </ul>
        <b-modal id="modal-location-1" title="" hide-footer centered>
            <div class="d-block chart-image location-1">
                <h5>企業数</h5>
                <div class="modal-chart-list">
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/China-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/China.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Thailand-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Thailand.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Vietnam-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Vietnam.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Indonesia-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Indonesia.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Malaysia-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Malaysia.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Philippines-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Philippines.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Hongkong-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Hongkong.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Taiwan-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Taiwan.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Singapore-hover.jpg"/>
                        </div>
                    </div>
                </div>
                <div class="modal-bar-chart">
                    <img src="../../assets/location/Nikkei.jpg" class="pc"/>
                    <img src="../../assets/location/Nikkei-sp.jpg" class="sp"/>
                </div>
            </div>

        </b-modal>

        <b-modal id="modal-location-2" title="" hide-footer centered>
            <div class="d-block chart-image location-2">
                <h5>日系企業の業種割合</h5>
                <div class="modal-chart-list">
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/China-2-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/China-2.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Thailand-2-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Thailand-2.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Vietnam-2-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Vietnam-2.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Indonesia-2-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Indonesia-2.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Malaysia-2-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Malaysia-2.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Philippines-2-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Philippines-2.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Taiwan-2-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Taiwan-2.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Singapore-2-hover.jpg"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Hongkong-2-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Hongkong-2.jpg" class="top"/>
                        </div>
                    </div>
                </div>
                <div class="modal-bar-chart border-bottom">
                    <img src="../../assets/location/manufacture.jpg" class="pc"/>
                    <img src="../../assets/location/manufacture-sp.jpg" class="sp"/>
                </div>
                <div class="modal-bar-chart">
                    <img src="../../assets/location/non-manufacturing.jpg" class="pc"/>
                    <img src="../../assets/location/non-manufacturing-sp.jpg" class="sp"/>
                </div>
            </div>

        </b-modal>

        <b-modal id="modal-location-3" title="" hide-footer centered>
            <div class="d-block chart-image location-3">
                <h5>広告費の投下先</h5>
                <div class="modal-chart-list">
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/China-3-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/China-3.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Taiwan-3-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Taiwan-3.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Hongkong-3-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Hongkong-3.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Malaysia-3-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Malaysia-3.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Indonesia-3-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Indonesia-3.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Philippines-3-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Philippines-3.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Singapore-3-hover.jpg"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Vietnam-3-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Vietnam-3.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Thailand-3-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Thailand-3.jpg" class="top"/>
                        </div>
                    </div>
                </div>
                <div class="modal-bar-chart">
                    <img src="../../assets/location/invest_advertising.jpg" class="pc"/>
                    <img src="../../assets/location/invest_advertising-sp.jpg" class="sp"/>
                </div>
                <div class="advertising-expenses-list">
                    <div class="advertising-container">
                        <img src="../../assets/location/Internet.jpg"/>
                    </div>
                    <div class="advertising-container">
                        <img src="../../assets/location/Television.jpg"/>
                    </div>
                    <div class="advertising-container">
                        <img src="../../assets/location/Newspaper.jpg"/>
                    </div>
                    <div class="advertising-container">
                        <img src="../../assets/location/Outdoor.jpg"/>
                    </div>
                    <div class="advertising-container">
                        <img src="../../assets/location/Radio.jpg"/>
                    </div>
                    <div class="advertising-container">
                        <img src="../../assets/location/Magazine.jpg"/>
                    </div>
                    <div class="advertising-container">
                        <img src="../../assets/location/Cinema.jpg"/>
                    </div>
                </div>
            </div>

        </b-modal>

        <b-modal id="modal-location-4" title="" hide-footer centered>
            <div class="d-block chart-image location-4">
                <h5>在住日本人数/総人口</h5>
                <div class="modal-chart-list">
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/China-4-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/China-4.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Thailand-4-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Thailand-4.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Singapore-4-hover.jpg"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Malaysia-4-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Malaysia-4.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Taiwan-4-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Taiwan-4.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Hongkong-4-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Hongkong-4.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Vietnam-4-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Vietnam-4.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Indonesia-4-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Indonesia-4.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Philippines-4-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Philippines-4.jpg" class="top"/>
                        </div>
                    </div>
                </div>
                <div class="modal-bar-chart">
                    <img src="../../assets/location/Japanese_population.jpg" class="pc"/>
                    <img src="../../assets/location/Japanese_population-sp.jpg" class="sp"/>
                </div>
            </div>

        </b-modal>

        <b-modal id="modal-location-5" title="" hide-footer centered>
            <div class="d-block chart-image location-5">
                <h5>GDP Million USD</h5>
                <div class="modal-chart-list">
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/China-5-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/China-5.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Indonesia-5-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Indonesia-5.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Thailand-5-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Thailand-5.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Philippines-5-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Philippines-5.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Hongkong-5-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Hongkong-5.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Singapore-5-hover.jpg"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Malaysia-5-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Malaysia-5.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Vietnam-5-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Vietnam-5.jpg" class="top"/>
                        </div>
                    </div>
                    <div class="modal-chart-container">
                        <div class="modal-chart">
                            <img src="../../assets/location/Taiwan-5-hover.jpg" class="bottom"/>
                            <img src="../../assets/location/Taiwan-5.jpg" class="top"/>
                        </div>
                    </div>
                </div>
                <div class="modal-bar-chart border-bottom">
                    <img src="../../assets/location/GDP-1.jpg" class="pc"/>
                    <img src="../../assets/location/GDP-1-sp.jpg" class="sp"/>
                </div>
                <div class="modal-bar-chart">
                    <img src="../../assets/location/GDP-2.jpg" class="pc"/>
                    <img src="../../assets/location/GDP-2-sp.jpg" class="sp"/>
                </div>
            </div>

        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'SingaporeList',
    data() {
        return {
            availableAnimate: false,
            posts: [
                {
                    image: require('@/assets/location/location-singapore.jpg'),
                    image_hover: require('@/assets/location/location-singapore-hover.jpg'),
                    title: '企業数'
                },
                {
                    image: require('@/assets/location/location-singapore-2.jpg'),
                    image_hover: require('@/assets/location/location-singapore-2-hover.jpg'),
                    title: '日系企業の業種割合'
                },
                {
                    image: require('@/assets/location/location-singapore-3.jpg'),
                    image_hover: require('@/assets/location/location-singapore-3-hover.jpg'),
                    title: '広告費の投下先'
                },
                {
                    image: require('@/assets/location/location-singapore-4.jpg'),
                    image_hover: require('@/assets/location/location-singapore-4-hover.jpg'),
                    title: '在住日本人数/総人口'
                },
                {
                    image: require('@/assets/location/location-singapore-5.jpg'),
                    image_hover: require('@/assets/location/location-singapore-5-hover.jpg'),
                    title: 'GDP Million USD'
                }
            ]
        }
    },
    mounted () {
        setTimeout(function(scope) {
            scope.availableAnimate = true;
        }, 1000, this);
    }
}
</script>

<style lang="scss" scoped>
    .compare_image {
        position:relative;
        border: 1px solid #DDDDDD;
        border-top: 1px solid #000;
        img {
            &.top {
                position:relative;
                transition: opacity .4s ease-in-out;
                &:hover {
                    opacity: 0;
                }
            }
            &.bottom {
                position:absolute;
                left: 0;
            }
        }
    }

    .modal-chart {
        position:relative;
        img {
            &.top {
                position:relative;
                transition: opacity .4s ease-in-out;
                &:hover {
                    opacity: 0;
                }
            }
            &.bottom {
                position:absolute;
                left: 0;
            }
        }

        &:hover {
            img {
                &.top {
                    opacity: 0;
                }
            }
        }  
    }

    .china_list {
        padding-left: 0;
        margin-bottom: 54px;

        > li {
            list-style: none;
            width: 30.8%;

            &:not(:nth-child(3n-2)) {
                margin-left: 3.8%;
            }

            &:nth-child(n+4) {
                margin-top: -140px;
            }
        }

        a:hover {
            color: #000000;
            
            .compare_area span {
                border-bottom: 1px solid #000000;
            }

            .compare_image {
                border-top: 1px solid #F2AA00;
                img {
                    &.top {
                        opacity: 0;
                    }
                }
            }

        }
    }

    .compare_area {
        font-size: 20px;
        text-align: right;
        padding-right: 50px;
        margin-bottom: 14px;
        position: relative;
        outline:none;

        &::before,
        &::after {
            content: '';
            display: block;
            width: 20px;
            height: 20px;
            border-top: 2px solid #000000;
            position: absolute;
            right: 10px;
            top: 12px;
        }

        &::after {
            transform: rotate(90deg);
            right: 19px;
            top: 3px;
        }
    }

    .image {
        width: 100%;
        height: auto;
    }

    .chart-image {
        margin: 0 -1.5rem;
        h5 {
            font-size: 28px;
            letter-spacing: 1.12px;
            line-height: 1.43;
            margin-left: 2.4%;
        }
        .modal-chart-list {
            display: flex;
            flex-wrap: wrap;
            .modal-chart-container {
                width: 32.7%;
                position: relative;
                border-bottom: 1px solid #DDDDDD;
                border-right: 1px solid #DDDDDD;
                .modal-chart {
                    img {
                        width: 100%;
                    }
                    &::before {
                        content: '';
                        position: absolute;
                        top: -11px;
                        right: -1px;
                        height: 21px;
                        width: 1px;
                        background-color: #000000;
                        z-index: 2;
                    }
                    &::after {
                        content: '';
                        position: absolute;
                        top: -1px;
                        right: -11px;
                        height: 1px;
                        width: 21px;
                        background-color: #000000;
                        z-index: 2;
                    }
                }
                &:nth-child(3n+2) {
                    width: 34.6%;
                }
                &:nth-child(3n) {
                    border-right: unset;
                    .modal-chart {
                        &::after {
                            content: unset;
                        }
                        &::before {
                            content: unset;
                        }
                    }
                }
                &:nth-child(1), &:nth-child(2), &:nth-child(3) {
                    &::before {
                        content: unset;
                    }
                    .modal-chart {
                        &::after {
                            content: unset;
                        }
                        &::before {
                            content: unset;
                        }
                    }
                }
            }
        }
        .modal-bar-chart {
            width: 100%;
            padding: 60px 15px 40px;
            img {
                width: 100%;
                &.sp {
                    display: none;
                }
            }
            &.border-bottom {
                border-bottom: 1px solid #DDDDDD;
            }
            &:last-child {
                padding: 60px 15px 30px;
            }
        }
        .advertising-expenses-list {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-bottom: 15px;
            .advertising-container {
                width: 27.6%;
                margin: 40px 0;
                img {
                    width: 100%;
                }
            }
        }
        &.location-2 {
            .modal-bar-chart {
                padding: 60px 15px 100px;
                &:last-child {
                    padding: 60px 15px 50px;
                }
            }
        }
        &.location-4 {
            .modal-bar-chart {
                padding-bottom: 55px;
            }
        }
        &.location-5 {
            .modal-bar-chart {
                padding: 60px 15px 100px;
                &:last-child {
                    padding: 60px 15px 50px;
                }
            }
        }
    }

    @keyframes slide-in-up {
        0% {
            opacity: 0;
            transform: translate3d(0,20%,0);
        }

        100% {
            opacity: 1;
            transform: translateZ(0);
        }
    }

    .animate.slide-in-up {
        opacity: 0;
        transform: translate3d(0,20%,0);
    }

    .available-animate {
        .animate-active.slide-in-up {
            animation: slide-in-up 1s linear;
            animation-fill-mode: forwards;
        }
    }

    @media screen and (max-width: 1225px) {
        .china_list {
            > li:nth-child(n+4) {
                margin-top: -10%;
            }  
        }
    }

    @media screen and (max-width: 767px) {
        .works_block {
            margin-bottom: 100px;
        }

        .compare_image {
            img {
                &.top {
                    opacity: 0;
                }
            }
        }

        .china_list {
            display: block !important;
            margin-bottom: 58px;
            
            > li {
                width: 100%;

                &:not(:nth-child(3n-2)) {
                    margin-left: 0;
                }

                &:nth-child(n+4) {
                    margin-top: 0;
                }

                &:not(:last-child) {
                    margin-bottom: 50px;
                }
            }
        }
        .chart-image {
            margin: 0;
            h5 {
                margin-left: 7.7%;
            }

            .modal-chart-list {
                display: block;
                .modal-chart-container {
                    width: 100%;
                    border-right: none;
                    overflow: hidden;
                    .modal-chart {
                        &::before {
                            content: unset;
                        }
                        &::after {
                            content: unset;
                        }
                    }
                    &:nth-child(3n+2) {
                        width: 100%;
                        .modal-chart {
                            width: 111.4%;
                            margin-left: -5.7%;
                        }
                    }
                    &:nth-child(3n+1) {
                        .modal-chart {
                            width: 105.7%;
                        }
                    }
                    &:nth-child(3n) {
                        .modal-chart {
                            width: 105.7%;
                            margin-left: -5.7%;
                        }
                    }
                }
            }
            .modal-bar-chart {
                padding: 60px 0 60px!important;
                img {
                    width: 100%;
                    &.pc {
                        display: none;
                    }
                    &.sp {
                        display: block;
                    }
                }
                &:last-child {
                    padding: 60px 0 30px!important;
                }
            }
            .advertising-expenses-list {
                margin-bottom: 0;
                .advertising-container {
                    width: 100%;
                    margin: 40px 8%;
                    &:last-child {
                        margin-bottom: 25px;
                    }
                }
            }
            &.location-3 {
                .modal-bar-chart {
                    padding-bottom: 40px!important;
                }
            }
        }
    }
</style>
